import { outlinedInputClasses, SxProps, Theme } from '@mui/material';
import { commonStyles } from '~/theme/styles/commonStyles';

type TStyles = {
  root: SxProps<Theme>;
  label: SxProps<Theme>;
  helperText: SxProps<Theme>;
  paper: SxProps<Theme>;
};

export const styles: TStyles = {
  root: (theme: Theme) => ({
    width: '100%',

    '& .MuiInputBase-root': {
      display: 'flex',
    },
    '& .MuiInput-input': {
      padding: 0,
    },

    '& .MuiInputAdornment-root': {
      '& .MuiTypography-root': {
        [theme.breakpoints.down('sm')]: {
          fontSize: 10,
          mt: 0.1,
        },
        mt: 0.2,
      },
      '& .MuiTelInput-FlagImg': {
        [theme.breakpoints.down('sm')]: {
          height: 12,
        },
      },
    },

    [`& .${outlinedInputClasses.input}`]: {
      [theme.breakpoints.down('sm')]: {
        position: 'static',
        fontSize: 10,
        width: '100%',
        height: 25,
        mr: 0.2,
        transformOrigin: 'unset',
        transform: 'unset',
      },
      p: 0,
    },
  }),

  label: {
    width: '100%',
  },

  helperText: {
    margin: 0,
    minHeight: '14px',
  },
  paper: (theme: Theme) => ({
    pointerEvents: 'auto',
    backgroundColor: theme.palette.common.white,
    backgroundImage: 'none',
    maxHeight: 320,
    mr: 5,
    '& .MuiMenuItem-root': {
      mr: 1,
    },
    '& .MuiTypography-root, & .MuiListItemText-root': {
      minWidth: 0,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
    ...(commonStyles.scroll(theme) as Object),
  }),
};
